import PublicOffer from './PublicOffer';

export default PublicOffer;


// WEBPACK FOOTER //
// ./src/containers/PublicOffer/index.js